// import aggiungi from  './aggiungi'
import anomalie from './anomalie'
import modificaMassiva from './modifica-massiva'
import moduloRid from './modulo-rid'
import estrattoConto from './estratto-conto'
import insertIbans from './insert-ibans'
// import inserimentoMassivoEe from './inserimento-massivo-ee'
// import inserimentoMassivoGas from './inserimento-massivo-gas'

export default [
  // always
  // {
  //   'key': 'contratti-vendita-button-aggiungi',
  //   'label': 'AGGIUNGI CONTRATTO DI VENDITA',
  //   'classCss': 'p-button-secondary',
  //   'icon': ' pi pi-directions',
  //   'type': 'operation',
  //   'method': aggiungi,
  //   'display': 'always'
  // },
  {
    'key': 'contratti-vendita-button-anomalie', 
    'label': 'ANOMALIE',
    'classCss': 'p-button-secondary',
    'icon': ' pi pi-directions',
    'type': 'operation',
    'method': anomalie,
    'display': 'always'
  },
  {
    'key': 'contratti-vendita-button-insert-ibans', 
    'label': 'INSERISCI IBAN CONTRATTI',
    'classCss': 'p-button-secondary',
    'icon': 'pi pi-cloud-upload',
    'method': insertIbans,
    'display': 'always',
    'upload': true,
    'accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  },
  // {
  //   'key': 'contratti-vendita-button-inserimento-massivo-ee',
  //   'label': 'INSERIMENTO MASSIVO EE',
  //   'classCss': '',
  //   'icon': ' pi pi-fast-forward',
  //   'type': 'operation',
  //   'method': inserimentoMassivoEe,
  //   'display': 'always'
  // },
  // {
  //   'key': 'contratti-vendita-button-inserimento-massivo-gas',
  //   'label': 'INSERIMENTO MASSIVO GAS',
  //   'classCss': 'p-button-warning',
  //   'icon': ' pi pi-fast-forward',
  //   'type': 'operation',
  //   'method': inserimentoMassivoGas,
  //   'display': 'always'
  // },

  // on-data-filtered
  {
    'key': 'contratti-vendita-button-modifica-massiva',
    'label': 'MODIFICA MASSIVA',
    'classCss': 'p-button-secondary',
    'icon': ' pi pi-directions',
    'type': 'operation',
    'method': modificaMassiva,
    'display': 'on-data-filtered'
  },
  {
    'key': 'contratti-vendita-button-modulo-rid',
    'label': 'MODULO RID',
    'classCss': 'p-button-secondary',
    'icon': ' pi pi-directions',
    'type': 'operation',
    'method': moduloRid,
    'display': 'on-data-filtered'
  },
  {
    'key': 'contratti-vendita-button-estratto-conto',
    'label': 'ESTRATTO CONTO',
    'classCss': 'p-button-secondary',
    'icon': ' pi pi-directions',
    'type': 'operation',
    'method': estrattoConto,
    'display': 'on-data-filtered'
  },
]
